// extracted by mini-css-extract-plugin
module.exports = {"transmedia":"Transmedia_transmedia__9j2Kj","transmedia_img":"Transmedia_transmedia_img__2H59K"};